import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { DropdownButtonStyleStates } from './types';

const styles = {
  root: css``,
} satisfies Styles<DropdownButtonStyleStates>;

export const useStyles = withStyles(styles);
